import { useEffect, useState } from "react"
import { formatDate, getWeekDateInMonth } from "../../../Utils/Common"
import { Box, Button, ButtonGroup, IconButton,  Stack, Typography } from "@mui/material"
import { WeekDays } from "../../../Utils/Dict"
import {  NavigateBeforeOutlined, NavigateNextOutlined } from "@mui/icons-material"

const ScheduleBar = (props)=>{
    const {week_date,onChange} = props
    const [dates,setDates] = useState([])
    const [currentYear,setCurrentYear] = useState(new Date().getFullYear())
    const [currentMonth,setCurrentMonth] = useState(new Date().getMonth())
    const [clickItem,setClickItem] = useState()
    useEffect(()=>{
        week_date>=0 ? setDates(getWeekDateInMonth(currentYear,currentMonth,week_date)):setDates([])
    },[week_date,currentYear,currentMonth])

    const handlePreMonth = ()=>{
        let year = currentMonth==0?currentYear-1:currentYear
        let month = currentMonth==0?11:currentMonth-1
        setCurrentMonth(month)
        setCurrentYear(year)
        onChange && onChange(year,month+1)
    }
    const handleNextMonth = ()=>{
        let year = currentMonth==11?currentYear+1:currentYear
        let month = currentMonth==11?0:currentMonth+1
        setCurrentMonth(month)
        setCurrentYear(year)
        onChange && onChange(year,month+1)
    }
    const handlePreYear = ()=>{
        let y = currentYear-1
        setCurrentYear(y)
        onChange && onChange(y,currentMonth+1)
    }
    const handleNextYear = ()=>{
        let y = currentYear+1
        setCurrentYear(y)
        onChange && onChange(y,currentMonth+1)
    }
    const handleClickDate = (date)=>{
        if(date == clickItem) {
            setClickItem()
            onChange && onChange(currentYear,currentMonth+1)
        }else {
            setClickItem(date)
            onChange&&onChange(currentYear,currentMonth+1,date)
        }
    }
    return <Stack direction={"row"} sx={{ml:1,width:"710px"}}>
                <ButtonGroup variant="text">
                    <IconButton size={"small"} disabled><Typography sx={{fontSize:"12px",fontWeight:"bold",color:"#0288d1"}}>{week_date>=0 ? WeekDays[week_date]:"All Days"}</Typography></IconButton>
                    <IconButton aria-label="pre year" onClick={handlePreYear} size="small"><NavigateBeforeOutlined /></IconButton>
                    <IconButton size={"small"} sx={{p:0}}><Typography sx={{fontSize:"14px",color:"#0288d1"}}>{currentYear}</Typography></IconButton>
                    <IconButton aria-label="next year" onClick={handleNextYear} size="small"><NavigateNextOutlined /></IconButton>
                
                    <IconButton aria-label="pre month" onClick={handlePreMonth} size="small"><NavigateBeforeOutlined /></IconButton>
                    <IconButton size={"small"} sx={{p:0}}><Typography sx={{fontSize:"14px",color:"#0288d1"}}>{currentMonth+1}</Typography></IconButton>
                    <IconButton aria-label="next month" onClick={handleNextMonth} size="small"><NavigateNextOutlined /></IconButton>
                </ButtonGroup>
            {dates.length>0 && dates.map(date=>{
                return <Button key={date} onClick={()=>{handleClickDate(date)}}><Box sx={{fontWeight:clickItem == date?"bold":undefined,color:clickItem == date?"#0288d1":"gray"}}>{formatDate(date)}</Box></Button>
            })}
        </Stack>
}

export default ScheduleBar